export const ROUTES = {
  overview: '/statistics',
  details: '/statistics/details',
};
